<style lang="scss">
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/mixins";
  @use "../../../assets/css/design-system/utils";

  .icon-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    border-radius: 0.375rem;

    @include colors.background-color(aiSurfacePurple);

    &.small {
      padding: utils.in_rem(16px) utils.in_rem(16px);
      gap: utils.in_rem(8px);

      .header {
        display: flex;
        align-items: center;
        gap: utils.in_rem(4px);

        span {
          @include mixins.h5();
          @include colors.color(aiTextPurple);
        }
      }

      .body {
        span {
          @include mixins.body3-tooltip-and-caption();
          @include colors.color(textBlack);
        }
      }
    }

    &.large {
      padding: utils.in_rem(24px) utils.in_rem(24px);
      gap: utils.in_rem(16px);

      .header {
        display: flex;
        align-items: center;
        gap: utils.in_rem(8px);

        span {
          @include mixins.h4();
          @include colors.color(aiTextPurple);
        }
      }

      .body {
        span {
          @include mixins.body2();
          @include colors.color(textBlack);
        }
      }
    }
  }
</style>

<script>
  // NB: currently only built for OpportunityCard.svelte - different color schemes to be added when required
  import Icon from "../../atoms/Icon.svelte";
  /** @type {"small" | "large"} */
  export let size = "large";
  export let icon = "fa-solid fa-wave-pulse";
  export let header = "";

  export let style = "";
</script>

<div class="icon-card {size}" {style}>
  <div class="header">
    <Icon class="{icon} color-aiIconPurple" size="medium" />
    <span>{header}</span>
  </div>
  <div class="body">
    <span>
      <slot />
    </span>
  </div>
</div>
